import React from 'react'
import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import { makeStyles } from '@mui/styles'
import useContainerWidth from './useContainerWidth'

const useStyles = makeStyles(() => ({
  chartContainer: {
    padding: '1rem',
    marginBottom: '1rem',
  },
  chart: {
    width: '100%',
    height: '370px',
  },
}))

const BaseOneEntityChart = ({ data, index, categories, colors }) => {
  const classes = useStyles()
  const { containerRef, width } = useContainerWidth()

  const INTERVALS = [
    { maxWidth: 800, value: 5 },
    { maxWidth: 1280, value: 3 },
    { maxWidth: 1600, value: 1 },
    { maxWidth: Infinity, value: 0 },
  ]

  const getInterval = (containerWidth) =>
    INTERVALS.find(({ maxWidth }) => containerWidth < maxWidth)?.value ?? 0

  const interval = getInterval(width)

  return (
    <div className={classes.chartContainer} ref={containerRef}>
      <div className={classes.chart}>
        <ResponsiveContainer width="100%" height="100%">
          <RechartsLineChart
            data={data}
            margin={{
              top: 0,
              right: 30,
              left: 10,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={index} interval={interval} fontSize={12} />
            <YAxis fontSize={12} />
            <Tooltip
              contentStyle={{
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                border: '1px solid #ccc',
                padding: '5px 10px 5px 10px',
                color: '#000',
                borderRadius: '4px',
              }}
            />
            <Legend />
            {categories.map((category, idx) => (
              <Line
                key={category}
                type="monotone"
                dataKey={category}
                stroke={colors[idx % colors.length]}
                activeDot={{ r: 6 }}
              />
            ))}
          </RechartsLineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default BaseOneEntityChart
